import { render, staticRenderFns } from "./ClientDashboardList.vue?vue&type=template&id=603c0fea&"
import script from "./ClientDashboardList.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardList.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboardList.vue?vue&type=style&index=0&id=603c0fea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports